import React, {  Component } from 'react';

export default class PageNotFound extends Component {
  render() {
    return (
        <h2>Page Not Found</h2>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/components/PageNotFound/index.js